<template>
  <div>
    <section class="pt-4 mb-4">
      <div class="container">
        <div class="row">
          <div class="col-lg-6 text-center text-lg-left">
            <h1 class="fw-600 h4">{{ $t("所有商家") }}</h1>
          </div>
          <div class="col-lg-6">
            <ul
              class="breadcrumb bg-transparent p-0 justify-content-center justify-content-lg-end"
            >
              <li class="breadcrumb-item opacity-50">
                <router-link class="text-reset" to="/"
                  >{{ $t("首页") }}
                </router-link>
              </li>
              <li class="text-dark fw-600 breadcrumb-item">
                <a class="text-reset" href="javascript:void(0)">{{
                  $t("所有商家")
                }}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <section class="mb-2">
      <div class="container">
        <div
          class="row gutters-10 row-cols-xxl-3 row-cols-xl-3 row-cols-lg-2 row-cols-md-2 row-cols-1"
        >
          <SellerItem
            v-for="item in list"
            :key="item.id"
            :item="item"
            class="col"
          />
        </div>
        <PaginationComp
          :cur-page="curPage"
          :total-page="totalPage"
          @goto="goToPage"
        />
      </div>
    </section>
  </div>
</template>
<script>
import PaginationComp from "@/components/PaginationComp.vue";
import SellerItem from "@/components/SellerItem.vue";
import { getShopList } from "@/api/userShop";

export default {
  components: {
    PaginationComp,
    SellerItem
  },
  data() {
    return {
      totalPage: 0,
      curPage: 0,
      list: []
    };
  },
  methods: {
    async getList() {
      const pageSize = 200;
      const res = await getShopList({
        params: {
          curPage: this.curPage,
          pageSize
        }
      });
      this.list = res.data.records;
      this.totalPage = Math.ceil(parseInt(res.data.total) / pageSize);
      window.scrollTo(0, 0);
    },
    goToPage(page) {
      this.curPage = page;
      this.getList();
    }
  },
  created() {
    this.goToPage(1);
  }
};
</script>
